/**
 * Client instrumentation hook — keep this file free of server-only packages.
 * @see https://nextjs.org/docs/app/api-reference/file-conventions/instrumentation-client
 * @see https://docs.sentry.io/platforms/javascript/guides/nextjs/manual-setup/
 */
;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/home/folder/:id\",\"regex\":\"^/home/folder/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/notebook/:id\",\"regex\":\"^/notebook/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/p/:id\",\"regex\":\"^/p/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/scroll/:id\",\"regex\":\"^/scroll/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/system/:accessKey\",\"regex\":\"^/system/([^/]+)$\",\"paramNames\":[\"accessKey\"],\"hasOptionalPrefix\":false},{\"path\":\"/view/:slug\",\"regex\":\"^/view/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/about\"},{\"path\":\"/auth/forgot-password\"},{\"path\":\"/auth/reset-password\"},{\"path\":\"/billing\"},{\"path\":\"/billing/pricing\"},{\"path\":\"/billing/published\"},{\"path\":\"/chat\"},{\"path\":\"/contact\"},{\"path\":\"/forgot-password\"},{\"path\":\"/home\"},{\"path\":\"/library\"},{\"path\":\"/login\"},{\"path\":\"/onboarding/avatar\"},{\"path\":\"/pricing\"},{\"path\":\"/privacy\"},{\"path\":\"/sandbox\"},{\"path\":\"/sentry-example-page\"},{\"path\":\"/settings/account\"},{\"path\":\"/settings/billing\"},{\"path\":\"/settings/sessions\"},{\"path\":\"/signup\"},{\"path\":\"/terms\"},{\"path\":\"/trash\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.6";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import { initPostHogClient } from "@/lib/analytics/init-posthog-client";
import {
  initDatadogRum,
  onRouterTransitionStart as datadogOnRouterTransitionStart,
} from "@/lib/datadog/rum";

initPostHogClient();

const isDev = process.env.NODE_ENV === "development";

if (!isDev) {
  void import("@/lib/sentry/instrumentation-client-sentry").then((mod) => {
    mod.initSentryInstrumentationClient();
  });
}

initDatadogRum();

export async function onRouterTransitionStart(
  url: string,
  navigationType: "push" | "replace" | "traverse",
) {
  datadogOnRouterTransitionStart(url);

  if (isDev) return;

  const { onRouterTransitionStart: sentryOnRouterTransitionStart } =
    await import("@/lib/sentry/instrumentation-client-sentry");
  return sentryOnRouterTransitionStart(url, navigationType);
}
